import { Collection } from "./collection";
export class OrderedCollection extends Collection {
    constructor(...items) {
        super(...items);
        this._weightCallback = this._onWeightChanged;
    }
    _addInternal(items) {
        const inserted = this._insertInternal(items);
        if (inserted?.length) {
            for (const i of inserted) {
                i.weightChangedObservable?.add(this._weightCallback, -1, false, this, false);
            }
        }
        return inserted;
    }
    _insertInternal(items) {
        if (!items) {
            return [];
        }
        for (const item of items) {
            let index = this._items.findIndex((item) => (item.weight ?? 0) > (item.weight ?? 0));
            if (index === -1) {
                this._items.push(item);
            }
            else {
                this._items.splice(index, 0, item);
            }
        }
        return items;
    }
    _removeInternal(items) {
        const removed = super._removeInternal(items);
        if (removed?.length) {
            for (const i of removed) {
                i.weightChangedObservable?.removeCallback(this._weightCallback, this);
            }
        }
        return removed;
    }
    _onWeightChanged(eventData, eventState) {
        const item = eventData;
        if (item) {
            const inserted = this._insertInternal(super._removeInternal([item]));
            if (inserted?.length) {
                this.invalidate();
            }
        }
    }
}
//# sourceMappingURL=orderedCollection.js.map